new Swiper(".testimonial-slider",{

loop:true,

spaceBetween:30,

speed:700,

autoplay:{
delay:3500
},

pagination:{
el:".swiper-pagination",
clickable:true
},

breakpoints:{

320:{
slidesPerView:1.2
},

768:{
slidesPerView:2
},

992:{
slidesPerView:3
},

1200:{
slidesPerView:4
},

1600:{
slidesPerView:5
}

}

});